import React, {
  useEffect,
  useCallback,
  useState
} from 'react';
import { Popover } from 'antd-mobile';
import miWear from '@mi/miwear-jssdk';
import { Layout, Intl } from '../components';
import { getLang, getAllLang, ILangItem } from './getLang';
import './App.scss';
import { getQuery, setQuery } from '../utils/browser';
import { PrivacyType } from "./utils"
import privacy from "../utils/privacy"
import { setDir } from '../utils/dom';
import Copy from '../components/copy/copy';

let model = getQuery("model")
let type = getQuery("type")
let locale = getQuery("locale")
let region = privacy.region
let langs: Array<string> = []
const rtlLocales = ['ar', 'he', 'ug_cn']

function getMiAccountLocale(locale: string) {
  const miAccountLocales = ['ko_KR', 'zh_CN', 'zh_TW', 'en_US']
  const res = miAccountLocales.find(t => t.toLocaleLowerCase().startsWith(locale))
  if (res) {
    return res
  }
  const [a, b] = locale.split("_")
  if (b) {
    return [a, b.toUpperCase()].join("_")
  }
  return a
}

const contentTransform = (content: string, model: string, locale: string): string => {
  content = content.replace(
    /({{watch_privacy_policy}}|\(watch_privacy_policy\))/g,
    match => {
      const getPrivacyPolicyAbsolutePath = () => {
        const relativePath = `./index.html?type=watch_privacy_policy&model=${model}&locale=${locale}`;
        const a = document.createElement('a');
        a.href = relativePath;
        return a.href;
      };

      if (match === '{{watch_privacy_policy}}') {
        const absolutePath = getPrivacyPolicyAbsolutePath();
        return `[${absolutePath}](${absolutePath})`;
      } else if (match === '(watch_privacy_policy)') {
        console.log("matched")
        const absolutePath = getPrivacyPolicyAbsolutePath();
        return `(${absolutePath})`;
      }
      return '';
    }
  ).replace('https://account.xiaomi.com/about/protocol/agreement', `https://account.xiaomi.com/about/protocol/agreement?_locale=${getMiAccountLocale(locale)}`);
  return content;
};

// 字段结构适配 ant design
const langTransform = (
  lang: ILangItem[]
): { label: string; value: string }[] => {
  return lang.map(item => ({
    label: item.name,
    value: `${item.code}`
  }));
};

function getLangList() {
  let list = []
  if (region && (type === PrivacyType.Privacy || PrivacyType.Healthy || PrivacyType.Healthy_Abstract)) {
    list = langFilter(getLang(region), true)
  } else {
    list = langFilter(getAllLang())
  }
  return langTransform(list)
}

// 根据目前实际已经支持语言，过滤出实际可用的语言
const langFilter = (lang: ILangItem[], noCommon = false): ILangItem[] => {
  const res = lang.filter(item => {
    if (type === 'watch_user_exp') {
      return langs.includes(`${item.code}`);
    } else if (item.name === 'English (Korea)') {
      return ''
    } else {
      return langs.includes(`${item.code}`);
    }
  })
  // 若 en_in、en_us、en 等同时存在，则应该忽略通用英语
  if (noCommon && res.some(t => t.code.startsWith("en_"))) {
    return res.filter(t => t.code !== 'en')
  }
  return res
};

// 获取md源文件路径
function getSourcePath(lang: string) {
  if (type === PrivacyType.Experience || type === PrivacyType.Experience_v3
        || type === PrivacyType.Eensitive || type === PrivacyType.Healthy
        || type === PrivacyType.Risk_Tips
        || type === PrivacyType.SmartCard
        || type === PrivacyType.Healthy_Abstract || type === PrivacyType.Eensitive_v3) {
    return `./${type}/${lang}.md`
  } else {
    return `./${type}/${model}/${lang}.md`
  }
}

const App = (props: any) => {
  const [list, setList] = useState<Array<{
    label: string
    value: string
  }>>([])

  useEffect(() => {
    (async () => {
      langs = await privacy.load()
      model = privacy.model
      type = privacy.type
      region = privacy.region
      const data = getLangList()
      locale = privacy.supportedLocale
      if (!data.some(t => t.value === locale)) {
        locale = data[0].value
        // 对支持的语言，需要重新设置direction
        setDir(locale)
      }
      setList(data)
    })()
  }, []);

  const handleChange = useCallback(({ key }) => {
    const url = setQuery({ locale: key })
    miWear.redirectTo(url)
  }, []);

  if (!list.length) {
    return null;
  }

  const source = getSourcePath(locale)
  const fallbackSource = ['en', 'zh_cn'].map(getSourcePath)
  return (
    <>
      {Boolean(list.length) && (
        <>
          <Popover mask
            overlay={list.map(r => <Popover.Item key={r.value}>{r.label}</Popover.Item>)}
            onSelect={handleChange}
            placement={rtlLocales.indexOf(locale) >= 0 ? 'bottomLeft' : 'bottomRight'}
          >
            <div className="picker">{list.find(r => r.value === locale)?.label}</div>
          </Popover>
          <hr />
        </>
      )}
      <Layout source={source} fallback={fallbackSource} contentTransform={source => contentTransform(source, model, locale)}></Layout>
      <Copy></Copy>

    </>
  );
};

export default Intl(App);
